import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";

import ViewDesign from "../components/ViewDesign";
import ViewMetadata from "../components/ViewMetadata";
import ListDesignItems from "../components/ListDesignItems";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewDesignVersion from "../components/ViewDesignVersion";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import {getDesign, editDesign, addDesign} from "../utils/utilsDesign";


class Design extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };

        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/designs`;

    }

    componentDidMount(){
       this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }
    
    loadDesign(id){

        let StateChange = {};
        StateChange.Design = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Design = data;

            StateChange.FormData = data;

            StateChange.renderState = "loaded";
            StateChange.isLoaded = true;

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.Design.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Design"
                    break;
                }
            }

            this.setLayoutContent(id);

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Design = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getDesign(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;        
    };

    setup(){

        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            loadData: false,

            idDesign: null,
            Design: null,

            FormData: {},
            Controls: {
            },

            DesignItemFilters: {
                status:'in use'
            },

            countDesignItems : null,

            idVersion: null,

            action: null,

            updateToggle: 0,

            countVersions: null,
            newVersion: false,
        }

        StateChange.fallbackpath = `/designs`;
        if (this.props.location.state){
            if (this.props.location.state.fallbackpath){
                StateChange.fallbackpath = this.props.location.state.fallbackpath;
            }
        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idDesign = getParam('id', this.props);

        StateChange.idVersion = getParam('idVersion', this.props);

        if (StateChange.idDesign){
            this.loadDesign(StateChange.idDesign);
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

        return;
    };

    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.renderState = "error";

            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':

                switch (this.state.mode){
                    case 'new':
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                    case 'edit':
                            this.props.navigation(`/design/${this.state.idDesign}`);
                        break;
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idDesign){
                            this.props.navigation(`/design/${idDesign}`);
                        }.bind(this);

                        addDesign(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/design/${this.state.idDesign}`);
                        }.bind(this);

                        editDesign(this.dsd, this.state.idDesign, this.state.FormData, onUpdate, onError);

                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }

    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddDesignItem':
                this.props.navigation(`/design/${this.state.idDesign}/designitem?mode=new`);
                break;
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }

    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.Design){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idDesign} type='design' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idDesign}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    setLayoutContent(idDesign){

        if (!idDesign){
            idDesign = this.state.idDesign
        }

        if (this.context.hasLayout){
            this.context.Layout.setLeftAsDesign(idDesign);
        }

        return;
    }

    showError(){

        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";
    }

    get Breadcrumb(){
        let crumbs = [
            {path: "/designs", label: "Designs"}
        ];

        if (this.state.Design){
            crumbs.push({
                path: `/design/${this.state.idDesign}`,
                label: this.state.Design.name
            });
        }

        return crumbs;
    }

    render() {

        // Handle viewing a specific version
        if (this.state.idVersion){
            return(
                <ViewDesignVersion idDesign={this.state.idDesign} idVersion={this.state.idVersion}/>
            )
        }

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':

                return (
                <div>

                    <PD.Heading>{this.state.mode} Design</PD.Heading>

                    {this.state.isFailed &&
                        <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                    }

                    <form> 
                        <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                        <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                        <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                            {
                                this.dsd.config.ComponentStatuses.map(
                                    (status, posStatus) => 
                                        {
                                            return(
                                                <option key={posStatus} value={status}>{status}</option>
                                            )
                                        }
                                )
                            }
                        </PD.Select>

                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                    </form>

                </div>    
                );
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Design</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewDesign json={this.state.Design}/>
                    </div>
                )
            case 'view':
            default:

                if (!this.state.Design){
                    return <div/>
                }

                let countDesignItems = 0;
                if (this.state.Design.DesignItems){
                    countDesignItems = this.state.Design.DesignItems.length;
                }

                return (
                    <div>
                        <div>
                            <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                            <PD.Heading>Design:{this.state.Design.name}</PD.Heading>
                        </div>

                        {this.state.OfferEdit &&
                            <span style={{paddingRight:10}}>
                                <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                            </span>
                        }

                        <ViewDesign Design={this.state.Design}/>

                        <br/>

                        <PD.Tabs>

                            <div label={`Design Items(${countDesignItems})`}>
                                <div style={{display:"flex"}}>
                                    {this.state.OfferEdit && 
                                        <PD.Button name='btnAddDesignItem' value='add a new Design Item' onClick={this.handleButton}/>
                                    }
                                </div>

                                <ListDesignItems DesignItems={this.state.Design.DesignItems} idDesign={this.state.idDesign} />

                            </div>

                            <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                {this.versions()}
                            </div>

                            <div label='Developer'>

                                <table>
                                    {this.state.Design &&
                                        <tbody>
                                            <tr>
                                                <th style={{verticalAlign:"top"}}>DSD</th>
                                                <td><pre>
                                                    {JSON.stringify(this.state.Design,null,4)}{"\n\n"}
                                                </pre></td>
                                            </tr>
                                        </tbody>
                                    }
                                </table>

                            </div>

                            <div label='Metadata'>
                                <ViewMetadata Data={this.state.Design} />
                            </div>

                        </PD.Tabs>

                    </div>
                )
        };

        return <div />;
    };
};

// Wrap and export
export default function Design_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Design {...props} navigation={navigation} location={location} params={params} />;
}
